(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1639],{

/***/ 77408:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tour/[travelSlug]",
      function () {
        return __webpack_require__(24630);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_pages_TravelPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26465);
/* harmony import */ var _components_elements_seo_SeoHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32192);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27802);




var TravelSinglePage = function(param) {
    var travel = param.travel, cmsConfig = param.cmsConfig;
    if (!travel.seoSettings.ogImage.publicId) {
        travel.seoSettings.ogImage = travel.mainImage;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_seo_SeoHeader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                seoSettings: travel.seoSettings
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_context__WEBPACK_IMPORTED_MODULE_3__/* .TravelIdContext.Provider */ .Hu.Provider, {
                value: travel.id,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages_TravelPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    travel: travel,
                    cmsConfig: cmsConfig
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (TravelSinglePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [789,7478,2367,1664,2247,8037,5583,562,651,6212,9836,2027,6299,5943,3311,4476,9774,2888,179], function() { return __webpack_exec__(77408); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);